// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AdminAuthProvider = registerClientReference(
    function() { throw new Error("Attempted to call AdminAuthProvider() from the server but AdminAuthProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-auth-provider.tsx",
    "AdminAuthProvider",
);
export const useAdminAuth = registerClientReference(
    function() { throw new Error("Attempted to call useAdminAuth() from the server but useAdminAuth is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-auth-provider.tsx",
    "useAdminAuth",
);
